import { Preloader } from '@hts/entities/Preloader';
import { mainActions, useAppDispatch } from '@hts/shared/libs';
import { IGetEditOrderDataResponse } from '@hts/shared/types';
import { HtslIcon, HtsTypography } from '@hts/shared/ui';
import { memo, useCallback } from 'react';
import { useCardContext, useGetCard } from '../libs';
import styles from '../styles/NewCardItem.module.scss';
import { PreviewBlock } from './CardPreview';
import { CardInfoContent } from './InfoContent';

interface ICardItemProps {
  cardId: string;
  resendCard: false;
}

interface IResendCardProps {
  resendCard: true;
  editOrderData?: IGetEditOrderDataResponse;
}

export const NewCardItem: React.FC<ICardItemProps | IResendCardProps> = memo((props) => {
  const setMusicList = useCardContext((state) => state.setMusicList);
  const setDraftCheckedMusicId = useCardContext((state) => state.setDraftCheckedMusicId);

  const dispatch = useAppDispatch();

  const isResendCard = props.resendCard;

  const toggleActiveCategory = useCallback((set: boolean) => {
    if (set) {
      dispatch(mainActions.setActiveCategory(''));
    } else {
      dispatch(mainActions.unsetActiveCategory());
    }
  }, []);

  const { cardData } = useGetCard({
    cardId: !isResendCard ? props.cardId : undefined,
    editOrderData: isResendCard ? props.editOrderData : undefined,
    setDraftCheckedMusicId,
    setMusicList,
    toggleActiveCategory,
  });

  const isLoading = !isResendCard && cardData.isLoading;
  const isUninitialized = !isResendCard && cardData.isUninitialized;

  if (isLoading || isUninitialized) {
    return (
      <div className={styles.preloaderContainer}>
        <Preloader />
      </div>
    );
  }

  if (cardData.isError) {
    return (
      <div className={styles.notFoundContainer}>
        <HtsTypography variant="h1">Card Not Found</HtsTypography>
      </div>
    );
  }

  return (
    <section className={styles.sectionContainer}>
      <div className={styles.container}>
        <div className={styles.infoContainer}>
          <CardInfoContent resendCard={isResendCard} />
        </div>

        <div className={styles.previewContainer}>
          <PreviewBlock />

          <div className={styles.watermarkContainer}>
            <HtslIcon icon="attention-circle" color="remove" />

            <HtsTypography color="remove" variant="caption">
              Watermarks will not appear on the final card
            </HtsTypography>
          </div>
        </div>
      </div>
    </section>
  );
});
